const types = [
  "REAL",
  "SINT",
  "LINT",
  "DINT",
  "DATE",
  "DWORD",
  "DT",
  "TOD",
  "UDINT",
  "WORD",
  "STRING",
  "LWORD",
  "UINT",
  "LREAL",
  "BYTE", 
  "USINT",
  "ULINT",
  "BOOL",
  "TIME",
  "INT",
];

const typeConversions = [];

for (const type of types) {
  for (const toType of types) {
    if (type !== toType) {
      const name = `${type}_TO_${toType}`;
      typeConversions.push({
        id: `conversion_${name}`,
        elementType: "typeConversionPou",
        name,
        inputs: [{ name: "IN", style: "leftPort" }],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      });
    }
  }
}

export default {
  projectId: undefined,
  projectProperties: {
    fileHeaderId: undefined,
    contentHeaderId: undefined,
    project: {},
    author: {},
    graphics: {
      pageSize: {
        id: undefined,
      },
      fbd: {
        id: undefined,
      },
      ld: {
        id: undefined,
      },
      sfc: {
        id: undefined,
      },
    },
    miscellaneous: {},
  },
  configuration: {
    id: undefined,
    name: "config",
    globalVars: [],
    resources: [],
  },
  pous: [],
  dataTypes: [],

  addItem: {
    componentName: undefined,
    itemTempId: undefined,
    showDialog: false,
    pouType: undefined,
  },

  commonPous: {
    standardFunctionBlocks: [
      {
        id: "stdFunctionBlock_sr",
        elementType: "standardFunctionBlockPou",
        name: "SR",
        variableName: "SR",
        executionOrder: 0,
        inputs: [
          { name: "S1", style: "leftPort" },
          { name: "R", style: "leftPort" },
        ],
        outputs: [{ name: "Q1", style: "rightPort" }],
      },
      {
        id: "stdFunctionBlock_rs",
        elementType: "standardFunctionBlockPou",
        name: "RS",
        variableName: "RS",
        executionOrder: 0,
        inputs: [
          { name: "S", style: "leftPort" },
          { name: "R1", style: "leftPort" },
        ],
        outputs: [{ name: "Q1", style: "rightPort" }],
      },
      {
        id: "stdFunctionBlock_sema",
        elementType: "standardFunctionBlockPou",
        name: "SEMA",
        variableName: "SEMA",
        executionOrder: 0,
        inputs: [
          { name: "CLAIM", style: "leftPort" },
          { name: "RELEASE", style: "leftPort" },
        ],
        outputs: [{ name: "BUSY", style: "rightPort" }],
      },
      {
        id: "stdFunctionBlock_rTrig",
        elementType: "standardFunctionBlockPou",
        name: "R_TRIG",
        variableName: "R_TRIG",
        executionOrder: 0,
        inputs: [{ name: "CLK", style: "leftPort" }],
        outputs: [{ name: "Q", style: "rightPort" }],
      },
      {
        id: "stdFunctionBlock_fTrig",
        elementType: "standardFunctionBlockPou",
        name: "F_TRIG",
        variableName: "F_TRIG",
        executionOrder: 0,
        inputs: [{ name: "CLK", style: "leftPort" }],
        outputs: [{ name: "Q", style: "rightPort" }],
      },
      {
        id: "stdFunctionBlock_ctu",
        elementType: "standardFunctionBlockPou",
        name: "CTU",
        variableName: "CTU",
        executionOrder: 0,
        inputs: [
          { name: "CU", style: "inPort" },
          { name: "R", style: "leftPort" },
          { name: "PV", style: "leftPort" },
        ],
        outputs: [
          { name: "Q", style: "rightPort" },
          { name: "CV", style: "rightPort" },
        ],
      },
      {
        id: "stdFunctionBlock_ctuDint",
        elementType: "standardFunctionBlockPou",
        name: "CTU_DINT",
        variableName: "CTU_DINT",
        executionOrder: 0,
        inputs: [
          { name: "CU", style: "inPort" },
          { name: "R", style: "leftPort" },
          { name: "PV", style: "leftPort" },
        ],
        outputs: [
          { name: "Q", style: "rightPort" },
          { name: "CV", style: "rightPort" },
        ],
      },
      {
        id: "stdFunctionBlock_ctuLint",
        elementType: "standardFunctionBlockPou",
        name: "CTU_LINT",
        variableName: "CTU_LINT",
        executionOrder: 0,
        inputs: [
          { name: "CU", style: "inPort" },
          { name: "R", style: "leftPort" },
          { name: "PV", style: "leftPort" },
        ],
        outputs: [
          { name: "Q", style: "rightPort" },
          { name: "CV", style: "rightPort" },
        ],
      },
      {
        id: "stdFunctionBlock_ctuUdint",
        elementType: "standardFunctionBlockPou",
        name: "CTU_UDINT",
        variableName: "CTU_UDINT",
        executionOrder: 0,
        inputs: [
          { name: "CU", style: "inPort" },
          { name: "R", style: "leftPort" },
          { name: "PV", style: "leftPort" },
        ],
        outputs: [
          { name: "Q", style: "rightPort" },
          { name: "CV", style: "rightPort" },
        ],
      },
      {
        id: "stdFunctionBlock_ctuUlint",
        elementType: "standardFunctionBlockPou",
        name: "CTU_ULINT",
        variableName: "CTU_ULINT",
        executionOrder: 0,
        inputs: [
          { name: "CU", style: "inPort" },
          { name: "R", style: "leftPort" },
          { name: "PV", style: "leftPort" },
        ],
        outputs: [
          { name: "Q", style: "rightPort" },
          { name: "CV", style: "rightPort" },
        ],
      },
      {
        id: "stdFunctionBlock_ctd",
        elementType: "standardFunctionBlockPou",
        name: "CTD",
        variableName: "CTD",
        executionOrder: 0,
        inputs: [
          { name: "CD", style: "inPort" },
          { name: "LD", style: "leftPort" },
          { name: "PV", style: "leftPort" },
        ],
        outputs: [
          { name: "Q", style: "rightPort" },
          { name: "CV", style: "rightPort" },
        ],
      },
      {
        id: "stdFunctionBlock_ctdDint",
        elementType: "standardFunctionBlockPou",
        name: "CTD_DINT",
        variableName: "CTD_DINT",
        executionOrder: 0,
        inputs: [
          { name: "CD", style: "inPort" },
          { name: "LD", style: "leftPort" },
          { name: "PV", style: "leftPort" },
        ],
        outputs: [
          { name: "Q", style: "rightPort" },
          { name: "CV", style: "rightPort" },
        ],
      },
      {
        id: "stdFunctionBlock_ctdLint",
        elementType: "standardFunctionBlockPou",
        name: "CTD_LINT",
        variableName: "CTD_LINT",
        executionOrder: 0,
        inputs: [
          { name: "CD", style: "inPort" },
          { name: "LD", style: "leftPort" },
          { name: "PV", style: "leftPort" },
        ],
        outputs: [
          { name: "Q", style: "rightPort" },
          { name: "CV", style: "rightPort" },
        ],
      },
      {
        id: "stdFunctionBlock_ctdUdint",
        elementType: "standardFunctionBlockPou",
        name: "CTD_UDINT",
        variableName: "CTD_UDINT",
        executionOrder: 0,
        inputs: [
          { name: "CD", style: "inPort" },
          { name: "LD", style: "leftPort" },
          { name: "PV", style: "leftPort" },
        ],
        outputs: [
          { name: "Q", style: "rightPort" },
          { name: "CV", style: "rightPort" },
        ],
      },
      {
        id: "stdFunctionBlock_ctdUlint",
        elementType: "standardFunctionBlockPou",
        name: "CTD_ULINT",
        variableName: "CTD_ULINT",
        executionOrder: 0,
        inputs: [
          { name: "CD", stype: "inPort" },
          { name: "LD", style: "leftPort" },
          { name: "PV", style: "leftPort" },
        ],
        outputs: [
          { name: "Q", style: "rightPort" },
          { name: "CV", style: "rightPort" },
        ],
      },
      {
        id: "stdFunctionBlock_ctud",
        elementType: "standardFunctionBlockPou",
        name: "CTUD",
        variableName: "CTUD",
        executionOrder: 0,
        inputs: [
          { name: "CU", style: "inPort" },
          { name: "CD", style: "inPort" },
          { name: "R", style: "leftPort" },
          { name: "LD", style: "leftPort" },
          { name: "PV", style: "leftPort" },
        ],
        outputs: [
          { name: "QU", style: "rightPort" },
          { name: "QD", style: "rightPort" },
          { name: "CV", style: "rightPort" },
          { name: "CD_T", style: "rightPort" },
          { name: "CU_T", style: "rightPort" },
        ],
      },
      {
        id: "stdFunctionBlock_ctudDint",
        elementType: "standardFunctionBlockPou",
        name: "CTUD_DINT",
        variableName: "CTUD_DINT",
        executionOrder: 0,
        inputs: [
          { name: "CU", stype: "inPort" },
          { name: "CD", stype: "inPort" },
          { name: "R", style: "leftPort" },
          { name: "LD", style: "leftPort" },
          { name: "PV", style: "leftPort" },
        ],
        outputs: [
          { name: "QU", style: "rightPort" },
          { name: "QD", style: "rightPort" },
          { name: "CV", style: "rightPort" },
          { name: "CD_T", style: "rightPort" },
          { name: "CU_T", style: "rightPort" },
        ],
      },
      {
        id: "stdFunctionBlock_ctudLint",
        elementType: "standardFunctionBlockPou",
        name: "CTUD_LINT",
        variableName: "CTUD_LINT",
        executionOrder: 0,
        inputs: [
          { name: "CU", stype: "inPort" },
          { name: "CD", stype: "inPort" },
          { name: "R", style: "leftPort" },
          { name: "LD", style: "leftPort" },
          { name: "PV", style: "leftPort" },
        ],
        outputs: [
          { name: "QU", style: "rightPort" },
          { name: "QD", style: "rightPort" },
          { name: "CV", style: "rightPort" },
          { name: "CD_T", style: "rightPort" },
          { name: "CU_T", style: "rightPort" },
        ],
      },
      {
        id: "stdFunctionBlock_ctudUdint",
        elementType: "standardFunctionBlockPou",
        name: "CTUD_UDINT",
        variableName: "CTUD_UDINT",
        executionOrder: 0,
        inputs: [
          { name: "CU", stype: "inPort" },
          { name: "CD", stype: "inPort" },
          { name: "R", style: "leftPort" },
          { name: "LD", style: "leftPort" },
          { name: "PV", style: "leftPort" },
        ],
        outputs: [
          { name: "QU", style: "rightPort" },
          { name: "QD", style: "rightPort" },
          { name: "CV", style: "rightPort" },
          { name: "CD_T", style: "rightPort" },
          { name: "CU_T", style: "rightPort" },
        ],
      },
      {
        id: "stdFunctionBlock_ctudUlint",
        elementType: "standardFunctionBlockPou",
        name: "CTUD_ULINT",
        variableName: "CTUD_ULINT",
        executionOrder: 0,
        inputs: [
          { name: "CU", stype: "inPort" },
          { name: "CD", stype: "inPort" },
          { name: "R", style: "leftPort" },
          { name: "LD", style: "leftPort" },
          { name: "PV", style: "leftPort" },
        ],
        outputs: [
          { name: "QU", style: "rightPort" },
          { name: "QD", style: "rightPort" },
          { name: "CV", style: "rightPort" },
          { name: "CD_T", style: "rightPort" },
          { name: "CU_T", style: "rightPort" },
        ],
      },
      {
        id: "stdFunctionBlock_tp",
        elementType: "standardFunctionBlockPou",
        name: "TP",
        variableName: "TP",
        executionOrder: 0,
        inputs: [
          { name: "IN", style: "leftPort" },
          { name: "PT", style: "leftPort" },
        ],
        outputs: [
          { name: "Q", style: "rightPort" },
          { name: "ET", style: "rightPort" },
        ],
      },
      {
        id: "stdFunctionBlock_ton",
        elementType: "standardFunctionBlockPou",
        name: "TON",
        variableName: "TON",
        executionOrder: 0,
        inputs: [
          { name: "IN", style: "leftPort" },
          { name: "PT", style: "leftPort" },
        ],
        outputs: [
          { name: "Q", style: "rightPort" },
          { name: "ET", style: "rightPort" },
        ],
      },
      {
        id: "stdFunctionBlock_tof",
        elementType: "standardFunctionBlockPou",
        name: "TOF",
        variableName: "TOF",
        executionOrder: 0,
        inputs: [
          { name: "IN", style: "leftPort" },
          { name: "PT", style: "leftPort" },
        ],
        outputs: [
          { name: "Q", style: "rightPort" },
          { name: "ET", style: "rightPort" },
        ],
      },
    ],
    additionalFunctionBlocks: [
      {
        id: "additionalFunctionBlock_rtc",
        elementType: "additionalFunctionBlockPou",
        name: "RTC",
        variableName: "RTC",
        executionOrder: 0,
        inputs: [
          { name: "IN", style: "leftPort" },
          { name: "PDT", style: "leftPort" },
        ],
        outputs: [
          { name: "Q", style: "rightPort" },
          { name: "CDT", style: "rightPort" },
        ],
      },
      {
        id: "additionalFunctionBlock_integral",
        elementType: "additionalFunctionBlockPou",
        name: "INTEGRAL",
        variableName: "INTEGRAL",
        executionOrder: 0,
        inputs: [
          { name: "RUN", style: "leftPort" },
          { name: "R1", style: "leftPort" },
          { name: "RXIN1", style: "leftPort" },
          { name: "X0", style: "leftPort" },
          { name: "CYCLE", style: "leftPort" },
        ],
        outputs: [
          { name: "Q", style: "rightPort" },
          { name: "XOUT", style: "rightPort" },
        ],
      },
      {
        id: "additionalFunctionBlock_derative",
        elementType: "additionalFunctionBlockPou",
        name: "DERATIVE",
        variableName: "DERATIVE",
        executionOrder: 0,
        inputs: [
          { name: "RUN", style: "leftPort" },
          { name: "XIN", style: "leftPort" },
          { name: "CYCLE", style: "leftPort" },
        ],
        outputs: [{ name: "XOUT", style: "rightPort" }],
      },
      {
        id: "additionalFunctionBlock_pid",
        elementType: "additionalFunctionBlockPou",
        name: "PID",
        variableName: "PID",
        executionOrder: 0,
        inputs: [
          { name: "AUTO", style: "leftPort" },
          { name: "PV", style: "leftPort" },
          { name: "SP", style: "leftPort" },
          { name: "X0", style: "leftPort" },
          { name: "KP", style: "leftPort" },
          { name: "TR", style: "leftPort" },
          { name: "TD", style: "leftPort" },
          { name: "CYCLE", style: "leftPort" },
        ],
        outputs: [{ name: "XOUT", style: "rightPort" }],
      },
      {
        id: "additionalFunctionBlock_ramp",
        elementType: "additionalFunctionBlockPou",
        name: "RAMP",
        variableName: "RAMP",
        executionOrder: 0,
        inputs: [
          { name: "RUN", style: "leftPort" },
          { name: "X0", style: "leftPort" },
          { name: "X1", style: "leftPort" },
          { name: "TR", style: "leftPort" },
          { name: "CYCLE", style: "leftPort" },
        ],
        outputs: [
          { name: "BUSY", style: "rightPort" },
          { name: "XOUT", style: "rightPort" },
        ],
      },
      {
        id: "additionalFunctionBlock_hysteresis",
        elementType: "additionalFunctionBlockPou",
        name: "HYSTERESIS",
        variableName: "HYSTERESIS",
        executionOrder: 0,
        inputs: [
          { name: "XIN1", style: "leftPort" },
          { name: "XIN2", style: "leftPort" },
          { name: "EPS", style: "leftPort" },
        ],
        outputs: [{ name: "Q", style: "rightPort" }],
      },
    ],
    typeConversions,
    numerical: [
      {
        id: 'numerical_abs',
        elementType: "numericalPou",
        name: "ABS",
        inputs: [{ name: "IN", style: "leftPort" }],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'numerical_sqrt',
        elementType: "numericalPou",
        name: "SQRT",
        inputs: [{ name: "IN", style: "leftPort" }],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'numerical_ln',
        elementType: "numericalPou",
        name: "LN",
        inputs: [{ name: "IN", style: "leftPort" }],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'numerical_log',
        elementType: "numericalPou",
        name: "LOG",
        inputs: [{ name: "IN", style: "leftPort" }],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'numerical_exp',
        elementType: "numericalPou",
        name: "EXP",
        inputs: [{ name: "IN", style: "leftPort" }],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'numerical_sin',
        elementType: "numericalPou",
        name: "SIN",
        inputs: [{ name: "IN", style: "leftPort" }],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'numerical_cos',
        elementType: "numericalPou",
        name: "COS",
        inputs: [{ name: "IN", style: "leftPort" }],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'numerical_tan',
        elementType: "numericalPou",
        name: "TAN",
        inputs: [{ name: "IN", style: "leftPort" }],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'numerical_asin',
        elementType: "numericalPou",
        name: "ASIN",
        inputs: [{ name: "IN", style: "leftPort" }],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'numerical_acos',
        elementType: "numericalPou",
        name: "ACOS",
        inputs: [{ name: "IN", style: "leftPort" }],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'numerical_atan',
        elementType: "numericalPou",
        name: "ATAN",
        inputs: [{ name: "IN", style: "leftPort" }],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
    ],
    arithmetic: [
      {
        id: 'arithmetic_add',
        elementType: "arithmeticPou",
        name: "ADD",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'arithmetic_mul',
        elementType: "arithmeticPou",
        name: "MUL",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'arithmetic_sub',
        elementType: "arithmeticPou",
        name: "SUB",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'arithmetic_div',
        elementType: "arithmeticPou",
        name: "DIV",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'arithmetic_mod',
        elementType: "arithmeticPou",
        name: "MOD",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'arithmetic_expt',
        elementType: "arithmeticPou",
        name: "EXPT",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'arithmetic_move',
        elementType: "arithmeticPou",
        name: "MOVE",
        inputs: [{ name: "IN", style: "leftPort" }],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
    ],
    time: [
      {
        id: 'time_addTime',
        elementType: "timePou",
        name: "ADD_TIME",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'time_addTodTime',
        elementType: "timePou",
        name: "ADD_TOD_TIME",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'time_addDtTime',
        elementType: "timePou",
        name: "ADD_DT_TIME",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'time_mulTime',
        elementType: "timePou",
        name: "MULTIME",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'time_subTime',
        elementType: "timePou",
        name: "SUB_TIME",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'time_subDateDate',
        elementType: "timePou",
        name: "SUB_DATE_DATE",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'time_subTodTime',
        elementType: "timePou",
        name: "SUB_TOD_TIME",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'time_subTodTod',
        elementType: "timePou",
        name: "SUB_TOD_TOD",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'time_subDtTime',
        elementType: "timePou",
        name: "SUB_DT_TIME",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'time_subDtDt',
        elementType: "timePou",
        name: "SUB_DT_DT",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'time_divTime',
        elementType: "timePou",
        name: "DIVTIME",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
    ],
    bitShift: [
      {
        id: 'bitShift_shl',
        elementType: "bitShiftPou",
        name: "SHL",
        inputs: [
          { name: "IN", style: "leftPort" },
          { name: "N", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'bitShift_shr',
        elementType: "bitShiftPou",
        name: "SHR",
        inputs: [
          { name: "IN", style: "leftPort" },
          { name: "N", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'bitShift_ror',
        elementType: "bitShiftPou",
        name: "ROR",
        inputs: [
          { name: "IN", style: "leftPort" },
          { name: "N", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'bitShift_rol',
        elementType: "bitShiftPou",
        name: "ROL",
        inputs: [
          { name: "IN", style: "leftPort" },
          { name: "N", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
    ],
    bitWise: [
      {
        id: 'bitWise_and',
        elementType: "bitWisePou",
        name: "AND",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'bitWise_or',
        elementType: "bitWisePou",
        name: "OR",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'bitWise_xor',
        elementType: "bitWisePou",
        name: "XOR",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'bitWise_not',
        elementType: "bitWisePou",
        name: "NOT",
        inputs: [{ name: "IN", style: "leftPort" }],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
    ],
    selection: [
      {
        id: 'selection_sel',
        elementType: "selectionPou",
        name: "SEL",
        inputs: [
          { name: "G", style: "leftPort" },
          { name: "IN0", style: "leftPort" },
          { name: "IN1", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'selection_max',
        elementType: "selectionPou",
        name: "MAX",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'selection_min',
        elementType: "selectionPou",
        name: "MIN",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'selection_limit',
        elementType: "selectionPou",
        name: "LIMIT",
        inputs: [
          { name: "MN", style: "leftPort" },
          { name: "IN", style: "leftPort" },
          { name: "MX", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'selection_mux',
        elementType: "selectionPou",
        name: "MUX",
        inputs: [
          { name: "K", style: "leftPort" },
          { name: "IN0", style: "leftPort" },
          { name: "IN1", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
    ],
    comparision: [
      {
        id: 'comparision_gt',
        elementType: "comparisionPou",
        name: "GT",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'comparision_ge',
        elementType: "comparisionPou",
        name: "GE",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'comparision_eq',
        elementType: "comparisionPou",
        name: "EQ",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'comparision_lt',
        elementType: "comparisionPou",
        name: "LT",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'comparision_le',
        elementType: "comparisionPou",
        name: "LE",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'comparision_ne',
        elementType: "comparisionPou",
        name: "NE",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
    ],
    characterString: [
      {
        id: 'characterString_len',
        elementType: "characterStringPou",
        name: "LEN",
        inputs: [{ name: "IN", style: "leftPort" }],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'characterString_left',
        elementType: "characterStringPou",
        name: "LEFT",
        inputs: [
          { name: "IN", style: "leftPort" },
          { name: "L", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'characterString_right',
        elementType: "characterStringPou",
        name: "RIGHT",
        inputs: [
          { name: "IN", style: "leftPort" },
          { name: "L", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'characterString_mid',
        elementType: "characterStringPou",
        name: "MID",
        inputs: [
          { name: "IN", style: "leftPort" },
          { name: "L", style: "leftPort" },
          { name: "P", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'characterString_concat',
        elementType: "characterStringPou",
        name: "CONCAT",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'characterString_concatDateTod',
        elementType: "characterStringPou",
        name: "CONCAT_DATE_TOD",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'characterString_insert',
        elementType: "characterStringPou",
        name: "INSERT",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
          { name: "P", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'characterString_delete',
        elementType: "characterStringPou",
        name: "DELETE",
        inputs: [
          { name: "IN", style: "leftPort" },
          { name: "L", style: "leftPort" },
          { name: "P", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'characterString_replace',
        elementType: "characterStringPou",
        name: "REPLACE",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
          { name: "L", style: "leftPort" },
          { name: "P", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
      {
        id: 'characterString_find',
        elementType: "characterStringPou",
        name: "FIND",
        inputs: [
          { name: "IN1", style: "leftPort" },
          { name: "IN2", style: "leftPort" },
        ],
        outputs: [{ name: "OUT", style: "rightPort" }],
        executionOrder: 0,
      },
    ],
  },
};
